/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SuperReactionIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACR0lEQVR4nK1Vy4oTURCNLnygouJr6wN/QNSFLsRFIJCuR0duV/U4kq2CglvHRdDRcfAX/AEXouCgk42ZD5idoqsRHYVxEwQfIDpq5Ka7k+7OdOa2zIWib/etOqfqVN2kUtm4tQlYF4C1Y/dOEZ4X7geWq0j6HEg+ImsPWVejvTzx/cmDiS9icD4+79n9WGBjzHYkmUGW74OgnAHprSTzPjjJ28G53Ucko5UAmCNA+qYIGGNjlmN9f9aFQj+SF2uAy8p64MjaqzfC4zFBx4nAygKsr13AMQqeSUsEpEsp+ZZGJELWu87g3Le/yDoLoIfWbTLzpX3jGopjDEh/xtNkx7QTy5JtLpBeywSx3qhWJ3cAyZQjyb3RYYkqi15YnqUDjDE7o7Jxl6tcQHqn3pg4aqcLSKaB5XGKQD9kM5IpS4IsN/9HttiWUxLJr9La83gZbW/SE7RaADTrUcjA8gBJP5WSkeRHmmB5LSePwguJT6vV2swcnkaWR44yDiVC0rkCGR7mpwP9QN0uos4Ne+Br1fODE8aYLYh6ElgWU1reN8bsrtVqW9EPLiLLF8c+Xa4UrZoxB/JAUGIQgPVrvT6xN3sxGsFZZPlsn/Hlu14i26Kf8hQBSztil3buD2exFAHpKyvnAJhIziTgwxKlbb/3SfzglHvmskIkh7OZk3QLnLv2/Fyzuc1Nd3k5Ap5UgCTzuUsy71oBkH5D1ts2kcKpSffAgme++1oFlqfA+g5IfwPJHyR5b+ccWK4QNfeMBc70gqSbZL5R6x+UweUi6veUwgAAAABJRU5ErkJggg==)
 */
export const SuperReactionIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M15.4 1.53A11 11 0 0 0 1.63 15.68c1.4-1.2 3.8-.81 4.54 1.18l.26.7.7.27c2 .73 2.4 3.14 1.19 4.54A11 11 0 0 0 22.47 8.6a2.93 2.93 0 0 1-5.21-.57l-.34-.93a.05.05 0 0 0-.03-.03l-.93-.34a2.93 2.93 0 0 1-.56-5.2ZM6.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-2.79.54c.27-.43.02-.95-.43-1.09l-4.06-1.23c-.45-.14-.94.15-.96.66a3.02 3.02 0 0 0 2.05 3.06c1.29.4 2.66-.21 3.4-1.4Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M19.42 3.88c.24.22.48.46.7.7a4 4 0 0 0-.12.14c-.2-.27-.45-.51-.72-.72l.14-.12Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M19.09.63a.97.97 0 0 1 1.82 0l.34.93a2 2 0 0 0 1.19 1.19l.93.34a.97.97 0 0 1 0 1.82l-.93.34a2 2 0 0 0-1.19 1.19l-.34.93a.97.97 0 0 1-1.82 0l-.34-.93a2 2 0 0 0-1.19-1.19l-.93-.34a.97.97 0 0 1 0-1.82l.93-.34a2 2 0 0 0 1.19-1.19l.34-.93ZM2.7 17.55a.85.85 0 0 1 1.6 0l.26.71a2 2 0 0 0 1.18 1.18l.7.26a.85.85 0 0 1 0 1.6l-.7.26a2 2 0 0 0-1.18 1.18l-.26.7a.85.85 0 0 1-1.6 0l-.26-.7a2 2 0 0 0-1.18-1.18l-.7-.26a.85.85 0 0 1 0-1.6l.7-.26a2 2 0 0 0 1.18-1.18l.26-.7Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
